define(["data/config"], function(config) {
    var $window = $(window);

    var onSubmit = function($element, params) {
        if (params.lastClick && params.lastClick.length > 0) {
            if (params.lastClick.attr("name")) {
                var $input = $('<input type="hidden">')
                    .attr("name", params.lastClick.attr("name"))
                    .attr("value", params.lastClick.val());
                $element.append($input);
            }
        }

        if (params.lastClick && params.lastClick.data("action")) {
            var action = params.lastClick.data("action");
            var confirm_message = params.lastClick.data("confirm-message") ? params.lastClick.data("confirm-message") : "This action cannot be undone. Are you sure?";
            if(params.lastClick.data("actionConfirm") && !window.confirm(confirm_message)) {
                return false;
            };
        } else {
            var action = $element.attr("action");
        }

        if (params.lastClick && params.lastClick.hasClass("c_uiButton")) {
            params.lastClick.addClass("c_uiButton--loading");
        } else {
            $element
                .find(".c_uiButton[type=submit]")
                .addClass("c_uiButton--loading");
        }

        if ($element.attr("enctype") == "multipart/form-data") {
            var formData = new FormData();
            $element.find(":input[name]").each(function() {
                if ($(this).attr("type") == "file") {
                    if ($(this)[0].files.length) {
                        var file = $(this)[0].files[0];
                        formData.append($(this).attr("name"), file, file.name);
                    }
                }
            });
            var params = $element.serializeArray();
            $.each(params, function (i, val) {
                formData.append(val.name, val.value);
            });
            var rq = $.ajax({
                url: action,
                data: formData,
                processData: false,
                contentType: false,
                type: "POST"
            });
        } else {
            var rq = $.post(action, $element.serialize());
        }

        var CloseAndGoto = function(params) {
            if (!params) {
                var params = {
                    type: "saved",
                    reload: true
                };
            }
            var parent = $element.parents(
                "." + config.component.window.canvasClassName
            );
            if (params.reload == false) {
                if (parent.length > 0) {
                    parent.children().trigger(config.events.windowRequestClose, {
                        isCancel: false
                    });
                }
                require(["componentClasses/feedbackBall"], function(
                    FeedbackBall
                ) {
                    new (FeedbackBall(params)).place();
                });
                if(params.partialReload){
                    require(["componentClasses/partialReload"], function(
                        PartialReload
                    ) {
                        PartialReload(params.partialReload); 
                    });
                }
            }
            else if (parent.length > 0) {
                parent.children().trigger(config.events.windowRequestClose, {
                    isCancel: false
                });
                require(["componentClasses/feedbackBall"], function(
                    FeedbackBall
                ) {
                    new (FeedbackBall(params)).place();
                    if (params.redirect) {
                        window.location.href = params.redirect;
                    } else if (params.reload) {
                        window.location.reload();
                    }
                });
                
                
               
            } else {
                require(["componentClasses/feedbackBall"], function(
                    FeedbackBall
                ) {
                    new (FeedbackBall(params)).place();
                    if (params.redirect) {
                        window.location.href = params.redirect;
                    } else if (params.reload) {
                        window.location.reload();
                    }
                });
            }
        };

        var fail = function(message) {
            require(["componentClasses/window"], function(Window) {
                new (Window({
                    text: message,
                    wrap: true,
                    titlebar: true,
                    title: "Something went wrong",
                    width: "narrow"
                })).place();
            });
        };

        rq.done(function(data) {
            if (data.result == "success") {
                if (data.replace) {
                    $element.parent().replaceWith(data.replace);
                    if (data.newUrl) {
                        history.replaceState(data.newUrl, window.document.title, data.newUrl);
                    }
                    $(window).trigger(config.events.significantDomChange);
                } else if (data.nextStep) {
                    args = data.args || {};
                    $element.html(
                        '<center class="u_metrics"><div class="c_feedbackLoading"></div></center>'
                    );
                    $.get(data.nextStep, args, function(data) {
                        if (
                            data.result == "success" &&
                            data.code == "nothing_to_do"
                        ) {
                            CloseAndGoto(data.feedback);
                        } else {
                            $element.replaceWith(data);
                            $window.trigger(config.events.significantDomChange);
                            $(window).trigger(
                                config.events.routerRouteLoaded,
                                data.nextStep
                            );
                        }
                    });
                } else {
                    CloseAndGoto(data.feedback);
                }
            } else {
                if (data.message) {
                    fail(data.message);
                }
            }
        });

        rq.fail(function(data) {
            if (data.status == 422) {
                var errorMessage = "Some fields are missing";
                for (error in data.responseJSON) {
                    errorMessage = data.responseJSON[error];
                }

                require(["componentClasses/feedbackBall"], function(
                    FeedbackBall
                ) {
                    new (FeedbackBall({
                        type: "error",
                        text: errorMessage
                    })).place();
                });
                for (a in data.responseJSON) {
                    $element
                        .find(
                            "[name='" +
                                a.split(".")[0] +
                                "[" +
                                a.split(".")[1] +
                                "]']"
                        )
                        .trigger(config.events.inputError);
                }
            } else {
                var message =
                    "Whoops! Something went wrong in our side, please contact us using the chat icon below if the problem persists.";
                if (data.status == 400 && data.responseJSON && data.responseJSON.error) {
                    message = data.responseJSON.error;
                    if(data.responseJSON.message && typeof data.responseJSON.message[0] !== undefined) {
                        message += ': ' + data.responseJSON.message[0];
                    }
                }
                else if (data.status == 404) {
                    message =
                        "Sorry, we couldn't find the page you were looking for!";
                } else if (data.status == 403) {
                    message = data.responseJSON.message;
                } else if (data.status == 410 && data.responseJSON[0]) {
                    if (data.responseJSON[0] == "session_is_full") {
                        message = "We’re sorry, this session is now full :-(";
                    }
                }
                fail(message);
            }
        });

        rq.always(function() {
            $element
                .find(".c_uiButton[type=submit]")
                .removeClass("c_uiButton--loading");
        });
    };

    var attach = function($element, params) {
        $element.on("click", '*[type="submit"], *[type="button"]', function(
            ev
        ) {
            params.lastClick = $(ev.target);
        });

        $element.on("submit", function(ev) {
            ev.preventDefault();
            onSubmit($element, params);
        });

        $element.on("click", '*[type="button"]', function(ev) {
            ev.preventDefault();
            onSubmit($element, params);
        });
    };

    return {
        name: "formAjax",
        defaultParameters: {
            reload: true
        },
        apply: attach
    };
});
